import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Container } from "reactstrap";
import { Row } from "reactstrap";
import { Col } from "reactstrap";
import { Link } from "react-router-dom";

const CustomMiniLoader = ({ status, text, style }) => {
  const LoaderIcon = (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1111 1.11111C11.1111 0.497461 10.6137 0 10 0C9.38635 0 8.88889 0.497461 8.88889 1.11111V3.33333C8.88889 3.94698 9.38635 4.44444 10 4.44444C10.6137 4.44444 11.1111 3.94698 11.1111 3.33333V1.11111Z"
        fill="#34C38F"
      />
      <path
        d="M11.1111 16.6667C11.1111 16.053 10.6137 15.5556 10 15.5556C9.38635 15.5556 8.88889 16.053 8.88889 16.6667V18.8889C8.88889 19.5025 9.38635 20 10 20C10.6137 20 11.1111 19.5025 11.1111 18.8889V16.6667Z"
        fill="#34C38F"
      />
      <path
        d="M20 10C20 10.6137 19.5025 11.1111 18.8889 11.1111H16.6667C16.053 11.1111 15.5556 10.6136 15.5556 10C15.5556 9.38635 16.053 8.88889 16.6667 8.88889H18.8889C19.5025 8.88889 20 9.38635 20 10Z"
        fill="#34C38F"
      />
      <path
        d="M3.33333 11.1111C3.94698 11.1111 4.44444 10.6137 4.44444 10C4.44444 9.38635 3.94698 8.88889 3.33333 8.88889H1.11111C0.497461 8.88889 0 9.38635 0 10C0 10.6136 0.497461 11.1111 1.11111 11.1111H3.33333Z"
        fill="#34C38F"
      />
      <path
        d="M17.0711 2.92893C17.505 3.36285 17.505 4.06637 17.0711 4.50028L15.4997 6.07163C15.0658 6.50555 14.3623 6.50555 13.9284 6.07163C13.4945 5.63771 13.4945 4.9342 13.9284 4.50028L15.4997 2.92893C15.9336 2.49502 16.6372 2.49502 17.0711 2.92893Z"
        fill="#34C38F"
      />
      <path
        d="M6.07162 15.4997C6.50554 15.0658 6.50554 14.3623 6.07162 13.9284C5.63771 13.4945 4.93419 13.4945 4.50028 13.9284L2.92893 15.4997C2.49501 15.9336 2.49501 16.6372 2.92893 17.0711C3.36284 17.505 4.06636 17.505 4.50028 17.0711L6.07162 15.4997Z"
        fill="#34C38F"
      />
      <path
        d="M17.0711 17.0711C16.6372 17.505 15.9336 17.505 15.4997 17.0711L13.9284 15.4997C13.4945 15.0658 13.4945 14.3623 13.9284 13.9284C14.3623 13.4945 15.0658 13.4945 15.4997 13.9284L17.0711 15.4997C17.505 15.9336 17.505 16.6372 17.0711 17.0711Z"
        fill="#34C38F"
      />
      <path
        d="M4.50028 6.07162C4.93419 6.50554 5.63771 6.50554 6.07162 6.07162C6.50554 5.63771 6.50554 4.93419 6.07162 4.50028L4.50028 2.92893C4.06636 2.49501 3.36284 2.49501 2.92893 2.92893C2.49501 3.36284 2.49501 4.06636 2.92893 4.50028L4.50028 6.07162Z"
        fill="#34C38F"
      />
    </svg>
  );
  const SuccessIcon = (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 8.71415L7.92308 14.4284L19 1.57129"
        stroke="#34C38F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  return (
    <div style={style}>
      {status ? (
        <LoaderStyled className="me-2">{LoaderIcon}</LoaderStyled>
      ) : (
        <span className="fade-in-custom-animate me-2">{SuccessIcon}</span>
      )}
      <span style={{ color: "#34C38F", fontWeight: "500" }}>{text}</span>
    </div>
  );
};

const LoaderStyled = styled.span`
  svg {
    animation: circle 4s linear infinite;
  }

  @keyframes circle {
    0% {
      transform: rotate(0deg) translateX(0px) rotate(0deg);
    }
    100% {
      transform: rotate(360deg) translateX(0px) rotate(360deg);
    }
  }
`;

CustomMiniLoader.propTypes = {
  text: PropTypes.string,
  status: PropTypes.bool,
  style: PropTypes.any,
};

export default CustomMiniLoader;
